var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-menu',{attrs:{"default-active":_vm.activeMenu,"unique-opened":true,"mode":_vm.mode}},_vm._l((_vm.sidebarRouters),function(route,index){return _c('sidebar-item',{key:route.path  + index,attrs:{"item":route,"base-path":route.path}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }